module.exports = __webpack_public_path__ + "media/Mitch Murder - Telefuture Theme.ae09e5fa.mp3";